import { ApiCredentialStatus } from "../../interfaces/apiCredentials";

// YOSHI-10464: labels of the partner API credential lifecycle. The status is derived from
// revoked_at and expires_at, it is not a stored column, so the map lives here and not in an enum.
export const translateApiCredentialStatus: {
  [key in ApiCredentialStatus]: string;
} = {
  active: "Activa",
  expired: "Expirada",
  revoked: "Revocada",
};

export const getTranslatedApiCredentialStatus = (
  status: ApiCredentialStatus,
): string => {
  return translateApiCredentialStatus[status] || "Desconocida";
};
